import React, { useEffect, useState } from 'react';
import { cqAPI } from '../../lib/Auth';
import {
  Button, Text, Center, VStack
} from '@chakra-ui/react';

function StripeConnect() {
  const [isConnected, setIsConnected] = useState(false);
  const [link, setLink] = useState('');

  const getStatus = async () => {
    try {
      const response = await cqAPI.get('/settings/partners/stripe');
      if (response.data.connected) {
        setIsConnected(true);
      } else {
        setIsConnected(false);
        setLink(response.data.link);
      }
    } catch (error) {
      console.error('Failed to fetch Stripe status', error);
    }
  };

  useEffect(() => {
    getStatus();
  }, []);

  return (
    <>
      {isConnected ? (
        <Center height="100vh" width="100%">
          <VStack spacing={4}>
            <Text>Connected to Stripe</Text>
          </VStack>
        </Center>
      ) : (
        <Center height="100vh" width="100%">
          <VStack spacing={4}>
            <Text>Connect your Stripe account to be able to process your customers payments for overage usages.</Text>
            <Button colorScheme="blue" as="a" href={link}>
              Connect to Stripe
            </Button>
          </VStack>
        </Center>
      )}
    </>
  );
}

export default StripeConnect;
